import vars from '../helpers';

let $popup = null;

const init = (container) => {
	$popup = $(container).find('.js-footer-team');

	$(container).find('.js-btn-up').click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 800);
	});

	if (!vars.isMobile()) {
		return;
	}

	vars.$document.on('click', (e) => {

		if ($popup.hasClass('isShown')) {
			$popup.removeClass('isShown');
		}

		if (!$popup.hasClass('isShown') && $(e.target).hasClass('js-footer-selector') || !$popup.hasClass('isShown') && $(e.target).closest('.js-footer-selector').length) {
			$popup.addClass('isShown');
		}
	});

	vars.$window.on('scroll resize', () => {
		$popup.removeClass('isShown');
	});
};

const destroy = () => {
	if (!vars.isMobile()) {
		return;
	}

	$popup.removeClass('isShown');
};

export default {
	init,
	destroy,
};
